var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.components),function(c,index){return _c(c.type,{key:index,tag:"component",attrs:{"params":c,"nav":_vm.nav}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }